import {ready} from '../main/utils';
import loadCompliantProducts from './compliant-products';

ready(() => {
  loadCompliantProducts();
});
